import * as Yup from "yup";
import { appIntl } from "../../../i18n/IntlGlobalProvider";

export const CreatePostSchema = Yup.object().shape({
  title: Yup.string().when("showtype", ([showtype], schema) => {
    return showtype !== "imageonly"
      ? schema.required(appIntl().formatMessage({ id: "mandatoryField" }))
      : schema.notRequired();
  }),
  content: Yup.string().when("showtype", ([showtype], schema) => {
    return showtype !== "imageonly"
      ? schema.required(appIntl().formatMessage({ id: "mandatoryField" }))
      : schema.notRequired();
  }),
  showtype: Yup.string().required(),
});
